module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-popup-container sc-checkout-container",
    class: {
      fadeOutTop: !_vm.show
    },
    style: (("z-index:" + (_vm.highestZIndex + 2)))
  }, [(_vm.isPaddleActive && ![0, 1].includes(_vm.form.pay_method)) ? _c('div', {
    staticClass: "payment-type-wrapper sc-form",
    staticStyle: {
      "padding": "42px 60px 30px"
    }
  }, [_c('a', {
    staticClass: "sc-back",
    style: (("background-image:url(" + _vm.scBaseUrl + "/assets/images/Back.svg)")),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.closeCheckout
    }
  }), _vm._v(" "), _c('PriceComponent', {
    attrs: {
      "price": _vm.price,
      "vat": _vm.vat,
      "has-parent": _vm.hasParent,
      "show": _vm.show
    }
  }), _vm._v(" "), (_vm.offer.options.length > 1) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThirdParty),
      expression: "!isThirdParty"
    }],
    staticClass: "sc-product-options mrgt-20"
  }, [_c('h2', [_vm._v("Product option")]), _vm._v(" "), _c('BaseFormRow', [_c('div', {
    staticClass: "sc-form-select-container sc-form-product-options"
  }, [_c('div', {
    staticClass: "sc-select-box",
    class: {
      'sc-select-has-error': _vm.errors.includes('optionId') ?
        true :
        false,
    }
  }, [_c('div', {
    ref: "product-options-sc-selectbox",
    staticClass: "sc-select-button brd",
    class: {
      'open-select-box': _vm.showProductOptions,
    },
    style: (("z-index:" + (_vm.highestZIndex + 17))),
    on: {
      "click": function($event) {
        _vm.showProductOptions = !_vm.showProductOptions
      }
    }
  }, [_c('div', {
    staticClass: "sc-selected-value"
  }, [_c('span', [_vm._v("\n                  " + _vm._s(_vm._f("TitleString")(_vm.selectedProductOption.name ||
    "Product Options")) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "sc-select-chevrons"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/symbols-arrow.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInFast",
      "mode": "out-in"
    }
  }, [(_vm.showProductOptions) ? _c('div', {
    directives: [{
      name: "closable",
      rawName: "v-closable",
      value: ({
        exclude: ['product-options-sc-selectbox'],
        handler: 'onCloseProductOptions',
      }),
      expression: "{\n                exclude: ['product-options-sc-selectbox'],\n                handler: 'onCloseProductOptions',\n              }"
    }],
    staticClass: "sc-options",
    style: (("z-index:" + (_vm.highestZIndex + 16)))
  }, _vm._l((_vm.offer.options), function(option, index) {
    return _c('div', {
      key: 'product_options_' + index + '_' + option.name,
      staticClass: "sc-option",
      class: {
        'sc-selected': option.ID == _vm.form.optionId
      },
      on: {
        "click": function($event) {
          _vm.form.optionId = option.ID
        }
      }
    }, [_c('span', {
      staticClass: "sc-select-option-label"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("TitleString")(option.name)) + "\n                    ")])])
  }), 0) : _vm._e()])], 1)])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sc-product-options mrgt-0"
  }, [(!_vm.userId) ? _c('h2', [_vm._v("Email address")]) : _vm._e(), _vm._v(" "), (!_vm.userId) ? _c('BaseFormRow', {
    class: {
      'mb-0': _vm.isEmailExist,
    }
  }, [_c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_email"),
      "placeholder": "Your email",
      "readonly": _vm.readOnly.includes('email') ? true : false,
      "error": _vm.errors.includes('email') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('email') ?
        _vm.errorMessages.email :
        '',
      "validation": "email",
      "tip": _vm.tipALign,
      "type": "email"
    },
    on: {
      "blur": _vm.checkEmailExist
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.availableProviders.includes('PAYPAL')) ? [_c('h2', {
    staticStyle: {
      "text-align": "center",
      "font-size": "22px",
      "font-weight": "normal",
      "font-family": "latoregular",
      "padding": "20px 5px 15px 5px"
    }
  }, [_vm._v("\n        How do you want to pay?\n      ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70px",
      "height": "5px",
      "background-color": "#ffd96b",
      "margin": "0 auto",
      "border-radius": "2px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sc-flex",
    staticStyle: {
      "padding": "30px",
      "margin": "0 auto",
      "text-align": "center"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.setPayType(0)
      }
    }
  }, [_c('img', {
    staticClass: "sc-purchase-modal__paypal-method-img",
    staticStyle: {
      "width": "100px",
      "margin": "20px"
    },
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/credit_card_method.png"),
      "alt": "Credit Card"
    }
  })]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.setPayType(1)
      }
    }
  }, [_c('img', {
    staticClass: "sc-purchase-modal__paypal-method-img",
    staticStyle: {
      "width": "100px",
      "margin": "20px"
    },
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/paypal_method.png"),
      "alt": "paypal"
    }
  })])])] : [_c('BaseFormRow', {
    staticClass: "relative mrgt-20"
  }, [_c('BaseButton', {
    attrs: {
      "variant": "big-button",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.setPayType(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.payButtonText))])], 1)], _vm._v(" "), (!_vm.isPaddleOpen && _vm.offer.faq && _vm.offer.faq.status) ? _c('p', {
    staticClass: "sc-faq-wrap"
  }, [_c('Faq', {
    attrs: {
      "faq": _vm.offer.faq
    }
  })], 1) : _vm._e()], 2) : _c('div', [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPaddleActive && _vm.form.pay_method == 0),
      expression: "isPaddleActive && form.pay_method == 0"
    }],
    key: ("sc-form-paddle-" + (_vm.offer.secret)),
    staticClass: "sc-form",
    class: {
      fadeInBottom: _vm.show
    },
    style: (("min-height:450px;z-index:" + _vm.highestZIndex + ";" + _vm.customHeight)),
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm._submitForm($event)
      }
    }
  }, [_c('a', {
    staticClass: "sc-back",
    style: (("background-image:url(" + _vm.scBaseUrl + "/assets/images/Back.svg)")),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.closeCheckout
    }
  }), _vm._v(" "), _c('PriceComponent', {
    attrs: {
      "price": _vm.price,
      "vat": _vm.vat,
      "has-parent": _vm.hasParent,
      "show": _vm.show
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sc-messages"
  }, [(_vm.resultErrorMessage.length) ? _c('p', {
    staticClass: "sc-error-text",
    domProps: {
      "innerHTML": _vm._s(_vm.resultErrorMessage)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.walletError) ? _c('p', {
    staticClass: "sc-error-text",
    domProps: {
      "innerHTML": _vm._s(_vm.walletError)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "paddleform"
  }), _vm._v(" "), (!_vm.isPaddleOpen && _vm.offer.faq && _vm.offer.faq.status) ? _c('p', {
    staticClass: "sc-faq-wrap"
  }, [_c('Faq', {
    attrs: {
      "faq": _vm.offer.faq
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isPaddleActive && _vm.showQuickPurchase) ? _c('form', {
    key: ("purchase-sc-form-" + (_vm.offer.secret)),
    staticClass: "sc-form sc-quick-buy",
    class: {
      fadeInBottom: _vm.show
    },
    style: (("z-index:" + _vm.highestZIndex)),
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitFormQuickBuy($event)
      }
    }
  }, [_c('a', {
    staticClass: "sc-back",
    style: (("background-image:url(" + _vm.scBaseUrl + "/assets/images/Back.svg)")),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.closeCheckout
    }
  }), _vm._v(" "), _c('PriceComponent', {
    attrs: {
      "price": _vm.price,
      "vat": _vm.vat,
      "has-parent": _vm.hasParent,
      "show": _vm.show
    }
  }), _vm._v(" "), _c('h2', [_vm._v("\n        Buy\n        "), _c('span', {
    staticClass: "sc-link sc-link_color_green",
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.cleanHTML(_vm.offer.title))
    }
  }), _vm._v(" "), (!_vm.offer.options || !_vm.offer.options.length) ? [_vm._v("\n          for "), _c('span', {
    attrs: {
      "id": (_vm.widgetKey + "_price")
    }
  }, [_vm._v("$" + _vm._s(_vm.price))])] : _vm._e(), _vm._v("\n        ?\n      ")], 2), _vm._v(" "), _c('div', {
    staticClass: "sc-messages"
  }, [(_vm.resultErrorMessage.length) ? _c('p', {
    staticClass: "sc-error-text",
    domProps: {
      "innerHTML": _vm._s(_vm.resultErrorMessage)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.walletError) ? _c('p', {
    staticClass: "sc-error-text",
    domProps: {
      "innerHTML": _vm._s(_vm.walletError)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.offer.options.length > 1) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThirdParty),
      expression: "!isThirdParty"
    }],
    staticClass: "sc-product-options mrgt-20"
  }, [_c('BaseFormRow', [_c('div', {
    staticClass: "sc-form-select-container sc-form-product-options"
  }, [_c('div', {
    staticClass: "sc-select-box",
    class: {
      'sc-select-has-error': _vm.errors.includes('optionId') ?
        true :
        false,
    }
  }, [_c('div', {
    ref: "product-options-sc-selectbox",
    staticClass: "sc-select-button brd",
    class: {
      'open-select-box': _vm.showProductOptions,
    },
    style: (("z-index:" + (_vm.highestZIndex + 17))),
    on: {
      "click": function($event) {
        _vm.showProductOptions = !_vm.showProductOptions
      }
    }
  }, [_c('div', {
    staticClass: "sc-selected-value"
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm._f("TitleString")(_vm.selectedProductOption.name ||
    "Product Options")) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "sc-select-chevrons"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/symbols-arrow.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInFast",
      "mode": "out-in"
    }
  }, [(_vm.showProductOptions) ? _c('div', {
    directives: [{
      name: "closable",
      rawName: "v-closable",
      value: ({
        exclude: ['product-options-sc-selectbox'],
        handler: 'onCloseProductOptions',
      }),
      expression: "{\n                  exclude: ['product-options-sc-selectbox'],\n                  handler: 'onCloseProductOptions',\n                }"
    }],
    staticClass: "sc-options",
    style: (("z-index:" + (_vm.highestZIndex + 16)))
  }, _vm._l((_vm.offer.options), function(option, index) {
    return _c('div', {
      key: 'product_options_' + index + '_' + option.name,
      staticClass: "sc-option",
      class: {
        'sc-selected': option.ID == _vm.form.optionId
      },
      on: {
        "click": function($event) {
          _vm.form.optionId = option.ID
        }
      }
    }, [_c('span', {
      staticClass: "sc-select-option-label"
    }, [_vm._v("\n                      " + _vm._s(_vm._f("TitleString")(option.name)) + "\n                      ")])])
  }), 0) : _vm._e()])], 1)])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isWalletSetup) ? [_c('BaseFormRow', [_c('div', {
    staticClass: "sc-form-select-container sc-user-type"
  }, [_c('div', {
    staticClass: "sc-select-box",
    class: {
      'sc-select-has-error': _vm.errors.includes('user_type') ?
        true :
        false,
    }
  }, [_c('label', {
    attrs: {
      "for": "user_type"
    }
  }, [_vm._v("I'm a")]), _vm._v(" "), _c('div', {
    ref: "user-type-sc-selectbox",
    staticClass: "sc-select-button brd",
    class: {
      'open-select-box': _vm.showUserTypes,
    },
    on: {
      "click": function($event) {
        _vm.showUserTypes = !_vm.showUserTypes
      }
    }
  }, [_c('div', {
    staticClass: "sc-selected-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.activeUserType))])]), _vm._v(" "), _c('div', {
    staticClass: "sc-select-chevrons cursor-pointer"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/symbols-arrow.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInFast",
      "mode": "out-in"
    }
  }, [(_vm.showUserTypes) ? _c('div', {
    directives: [{
      name: "closable",
      rawName: "v-closable",
      value: ({
        exclude: ['user-type-sc-selectbox'],
        handler: 'onCloseUserType',
      }),
      expression: "{\n                  exclude: ['user-type-sc-selectbox'],\n                  handler: 'onCloseUserType',\n                }"
    }],
    staticClass: "sc-options"
  }, [_c('div', {
    key: "user_type_1",
    staticClass: "sc-option",
    class: {
      'sc-selected': _vm.form.user_type == 1
    },
    on: {
      "click": function($event) {
        _vm.form.user_type = 1
      }
    }
  }, [_c('span', {
    staticClass: "sc-select-option-label"
  }, [_vm._v("Private User")])]), _vm._v(" "), _c('div', {
    key: "user_type_2",
    staticClass: "sc-option",
    class: {
      'sc-selected': _vm.form.user_type == 2
    },
    on: {
      "click": function($event) {
        _vm.form.user_type = 2
      }
    }
  }, [_c('span', {
    staticClass: "sc-select-option-label"
  }, [_vm._v("Business")])]), _vm._v(" "), _c('div', {
    key: "user_type_3",
    staticClass: "sc-option",
    class: {
      'sc-selected': _vm.form.user_type == 3
    },
    on: {
      "click": function($event) {
        _vm.form.user_type = 3
      }
    }
  }, [_c('span', {
    staticClass: "sc-select-option-label"
  }, [_vm._v("Organization")])]), _vm._v(" "), _c('div', {
    key: "user_type_4",
    staticClass: "sc-option",
    class: {
      'sc-selected': _vm.form.user_type == 4
    },
    on: {
      "click": function($event) {
        _vm.form.user_type = 4
      }
    }
  }, [_c('span', {
    staticClass: "sc-select-option-label"
  }, [_vm._v("Sole trader")])])]) : _vm._e()])], 1)]), _vm._v(" "), (!_vm.userId) ? [(_vm.isSelfHosted && !_vm.iframe) ? _c('a', {
    staticClass: "sc-login-link flex",
    attrs: {
      "data-target": "#login",
      "data-toggle": "modal",
      "data-dismiss": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    },
    on: {
      "click": _vm.closeCheckout
    }
  }, [_vm._v("\n              Already a user?"), _c('span', {
    staticClass: "has-tooltip"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/info.svg"),
      "alt": "info"
    }
  }), _vm._v(" "), _c('BaseToolTip', {
    staticClass: "tooltip-text",
    attrs: {
      "text": "This product is sold on Sellcodes.com. If you already have a Sellcodes account, please click to login.",
      "tip": "bottom-right"
    }
  })], 1)]) : _c('a', {
    staticClass: "sc-login-link flex",
    attrs: {
      "target": "_blank",
      "href": (_vm.scBaseUrl + "/" + (_vm.offer.secret_link) + "/?embLogin=1")
    }
  }, [_vm._v("\n              Already a user?"), _c('span', {
    staticClass: "has-tooltip"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/info.svg"),
      "alt": "info"
    }
  }), _vm._v(" "), _c('BaseToolTip', {
    staticClass: "tooltip-text",
    attrs: {
      "text": "This product is sold on Sellcodes.com. If you already have a Sellcodes account, please click to login.",
      "tip": "bottom-right"
    }
  })], 1)])] : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInTop",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [([2, 3, 4].includes(_vm.form.user_type)) ? _c('div', {
    key: "businessUserBlock",
    attrs: {
      "id": "businessUserBlock"
    }
  }, [_c('BaseFormRow', [_c('BaseInput', {
    staticClass: "mrgrt-8",
    attrs: {
      "id": (_vm.widgetKey + "_business_name"),
      "placeholder": "Business name",
      "error": _vm.errors.includes('business_name') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('business_name') ?
        _vm.errorMessages.business_name :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.business_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "business_name", $$v)
      },
      expression: "form.business_name"
    }
  }), _vm._v(" "), _c('BaseSelect', {
    staticClass: "mrglt-8",
    attrs: {
      "id": (_vm.widgetKey + "_residence_business"),
      "placeholder": "Business residence",
      "options": _vm.countries,
      "option-label": "name",
      "option-value": "alpha_2",
      "option-input": "alpha_3",
      "option-sub-label": "alpha_3",
      "label": "Business residence",
      "error": _vm.errors.includes('residence_business') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('residence_business') ?
        _vm.errorMessages.residence_business :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.residence_business),
      callback: function($$v) {
        _vm.$set(_vm.form, "residence_business", $$v)
      },
      expression: "form.residence_business"
    }
  })], 1), _vm._v(" "), (_vm.isEU && !_vm.showEUVat) ? _c('BaseFormRow', [_c('a', {
    staticClass: "vat-toggle-link",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.showEUVat = !_vm.showEUVat
      }
    }
  }, [_vm._v("Have an EU VAT number?")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInTop",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.isEU && _vm.showEUVat) ? [_c('BaseFormRow', [_c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_eu_vat_number"),
      "placeholder": "EU VAT number",
      "error": _vm.form.eu_vat_number.length &&
        (_vm.errors.includes('eu_vat_number') ||
          _vm.errorMessages.hasOwnProperty('eu_vat_number')) ?
        true :
        false,
      "success": _vm.form.eu_vat_valid == 1 && _vm.form.eu_vat_number.length,
      "success-message": _vm.successMessages.hasOwnProperty('eu_vat_number') ?
        _vm.successMessages.eu_vat_number :
        '',
      "error-message": _vm.errorMessages.hasOwnProperty('eu_vat_number') ?
        _vm.errorMessages.eu_vat_number :
        '',
      "size": "w-75",
      "is-vat": true
    },
    model: {
      value: (_vm.form.eu_vat_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "eu_vat_number", $$v)
      },
      expression: "form.eu_vat_number"
    }
  }), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "size": "w-25 h-40",
      "variant": "invert",
      "type": "button",
      "loading": _vm.vatLoader
    },
    on: {
      "click": function($event) {
        return _vm.checkVatNumber('vat')
      }
    }
  }, [_vm._v("Check")])], 1)] : _vm._e()], 2), _vm._v(" "), _c('BaseFormRow', [_c('h2', [_vm._v("Legal representative")])]), _vm._v(" "), _c('BaseFormRow', [_c('BaseInput', {
    staticClass: "mrgrt-8",
    attrs: {
      "id": (_vm.widgetKey + "_first_name_b"),
      "placeholder": "First name",
      "size": "w-50",
      "error": _vm.errors.includes('first_name') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('first_name') ?
        _vm.errorMessages.first_name :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.first_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "first_name", $$v)
      },
      expression: "form.first_name"
    }
  }), _vm._v(" "), _c('BaseInput', {
    staticClass: "mrglt-8",
    attrs: {
      "id": (_vm.widgetKey + "_last_name_b"),
      "placeholder": "Last name",
      "error": _vm.errors.includes('last_name') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('last_name') ?
        _vm.errorMessages.last_name :
        '',
      "tip": _vm.tipALign,
      "required": true,
      "size": "w-50"
    },
    model: {
      value: (_vm.form.last_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "last_name", $$v)
      },
      expression: "form.last_name"
    }
  })], 1), _vm._v(" "), (!_vm.userId) ? _c('BaseFormRow', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThirdParty),
      expression: "!isThirdParty"
    }],
    class: {
      'mb-0': _vm.isEmailExist,
    }
  }, [_c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_email_b"),
      "placeholder": "Your email",
      "readonly": _vm.readOnly.includes('email') ? true : false,
      "error": _vm.errors.includes('email') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('email') ?
        _vm.errorMessages.email :
        '',
      "validation": "email",
      "tip": _vm.tipALign,
      "type": "email"
    },
    on: {
      "blur": _vm.checkEmailExist
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEmailExist) ? _c('p', {
    staticClass: "email-exists-error"
  }, [_vm._v("\n              You already seem to have a Sellcodes account.\n              "), (_vm.isSelfHosted) ? _c('a', {
    staticClass: "sc-login-link flex",
    attrs: {
      "data-target": "#login",
      "data-toggle": "modal",
      "data-dismiss": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_vm._v("\n                Please login\n              ")]) : _c('a', {
    staticClass: "sc-login-link flex",
    attrs: {
      "target": "_blank",
      "href": (_vm.scBaseUrl + "/" + (_vm.offer.secret_link) + "/?embLogin=1")
    }
  }, [_vm._v("\n                Please login\n              ")])]) : _vm._e()], 1) : _c('div', {
    key: "privateUserBlock"
  }, [_c('BaseFormRow', [_c('BaseInput', {
    staticClass: "mrgrt-8",
    attrs: {
      "id": (_vm.widgetKey + "_first_name"),
      "placeholder": "First name",
      "size": "w-50",
      "required": true,
      "error": _vm.errors.includes('first_name') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('first_name') ?
        _vm.errorMessages.first_name :
        ''
    },
    model: {
      value: (_vm.form.first_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "first_name", $$v)
      },
      expression: "form.first_name"
    }
  }), _vm._v(" "), _c('BaseInput', {
    staticClass: "mrglt-8",
    attrs: {
      "id": (_vm.widgetKey + "_last_name"),
      "placeholder": "Last name",
      "required": true,
      "error": _vm.errors.includes('last_name') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('last_name') ?
        _vm.errorMessages.last_name :
        '',
      "tip": _vm.tipALign,
      "size": "w-50"
    },
    model: {
      value: (_vm.form.last_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "last_name", $$v)
      },
      expression: "form.last_name"
    }
  })], 1), _vm._v(" "), (!_vm.userId) ? _c('BaseFormRow', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThirdParty),
      expression: "!isThirdParty"
    }],
    class: {
      'mb-0': _vm.isEmailExist,
    }
  }, [_c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_email"),
      "placeholder": "Your email",
      "readonly": _vm.readOnly.includes('email') ? true : false,
      "error": _vm.errors.includes('email') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('email') ?
        _vm.errorMessages.email :
        '',
      "validation": "email",
      "tip": _vm.tipALign,
      "type": "email"
    },
    on: {
      "blur": _vm.checkEmailExist
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEmailExist) ? _c('p', {
    staticClass: "email-exists-error"
  }, [_vm._v("\n              You already seem to have a Sellcodes account.\n              "), (_vm.isSelfHosted) ? _c('a', {
    staticClass: "sc-login-link flex",
    attrs: {
      "data-target": "#login",
      "data-toggle": "modal",
      "data-dismiss": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_vm._v("\n                Please login\n              ")]) : _c('a', {
    staticClass: "sc-login-link flex",
    attrs: {
      "target": "_blank",
      "href": (_vm.scBaseUrl + "/" + (_vm.offer.secret_link) + "/?embLogin=1")
    }
  }, [_vm._v("\n                Please login\n              ")])]) : _vm._e()], 1)])] : _vm._e(), _vm._v(" "), (_vm.offer.options.length &&
    _vm.walletData.vatAmount &&
    _vm.walletData.vatAmount > 0
  ) ? _c('span', {
    staticClass: "sc-buy-text"
  }, [_c('i', [_vm._v("An additional\n          "), _c('span', {
    attrs: {
      "id": (_vm.widgetKey + "_vat_amount")
    }
  }, [_vm._v(_vm._s(_vm.vat))]), _vm._v(" USD will be\n          added "), _c('br'), _vm._v("(Value-Added Tax for\n          " + _vm._s(_vm.walletData.vatDetails.name) + ")")])]) : _c('span', {
    staticClass: "sc-buy-text"
  }, [_c('i', [_vm._v("\n          You’ll get charged " + _vm._s(_vm.price) + " USD\n          "), (_vm.walletData.vatAmount) ? [_vm._v("\n            (+" + _vm._s(_vm.vat) + " USD VAT)")] : _vm._e()], 2)]), _vm._v(" "), (!_vm.isBalanceExists &&
    _vm.eligibleCards &&
    _vm.eligibleCards.length > 1
  ) ? _c('div', {
    staticClass: "sc-card-list"
  }, [_c('BaseFormRow', [_c('h2', [_vm._v("Which Credit Card do you want to use?")])]), _vm._v(" "), _vm._l((_vm.eligibleCards), function(card) {
    return _c('div', {
      key: card.mp_creditcard_id,
      staticClass: "sc-card-list-item",
      class: {
        active: card.mp_creditcard_id == _vm.selected_card.mp_creditcard_id,
      },
      on: {
        "click": function($event) {
          _vm.selected_card = card
        }
      }
    }, [_vm._v("\n          " + _vm._s(((card.cardProvider) + " " + (card.last_four_digit))) + "\n        ")])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.addNewCard) ? _c('div', {
    staticClass: "sc-new-card-wrap"
  }, [_c('span', {
    staticClass: "sc-new-card"
  }, [_vm._v("Want to enter a\n          "), _c('a', {
    staticClass: "sc-new-card-link",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.addNewCard = true
      }
    }
  }, [_vm._v("new\n            " + _vm._s(!_vm.isBalanceExists &&
    _vm.eligibleCards &&
    _vm.eligibleCards.length > 1 ?
    "one" :
    "card") + " ")]), _vm._v("?")])]) : _vm._e(), _vm._v(" "), _c('BaseFormRow', [_c('BaseButton', {
    attrs: {
      "variant": "big-button",
      "type": "button"
    },
    on: {
      "click": _vm.submitFormQuickBuy
    }
  }, [_vm._v("Yes, buy it!")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInTop",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.showDiscount) ? _c('BaseFormRow', [_c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_discount_code"),
      "placeholder": "Discount Code",
      "size": "w-75",
      "error": _vm.errors.includes('discount_code') ||
        _vm.errorMessages.hasOwnProperty('discount_code') ?
        true :
        false,
      "success": _vm.form.discount_code.length > 0 &&
        _vm.successMessages.hasOwnProperty('discount_code'),
      "success-message": _vm.successMessages.hasOwnProperty('discount_code') ?
        _vm.successMessages.discount_code :
        '',
      "error-message": _vm.errorMessages.hasOwnProperty('discount_code') ?
        _vm.errorMessages.discount_code :
        '',
      "is-vat": true
    },
    model: {
      value: (_vm.form.discount_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "discount_code", $$v)
      },
      expression: "form.discount_code"
    }
  }), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "size": "w-25 h-40",
      "variant": "invert",
      "type": "button",
      "disabled": !_vm.form.discount_code.length,
      "loading": _vm.dCodeLoader
    },
    on: {
      "click": function($event) {
        return _vm.checkVatNumber('dcode')
      }
    }
  }, [_vm._v("Apply")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.walletData.purchased > 0) ? _c('span', {
    staticClass: "sc-buy-text"
  }, [_c('i', [_vm._v("Note: you already bought this item. To buy it\n          again, click on the\n          button above")])]) : _vm._e()], 2) : (!_vm.isPaddleActive || _vm.form.pay_method == 1) ? _c('form', {
    key: ("sc-form-" + (_vm.offer.secret)),
    staticClass: "sc-form",
    class: {
      fadeInBottom: _vm.show
    },
    style: (("z-index:" + _vm.highestZIndex)),
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm._submitForm($event)
      }
    }
  }, [_c('a', {
    staticClass: "sc-back",
    style: (("background-image:url(" + _vm.scBaseUrl + "/assets/images/Back.svg)")),
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.closeCheckout
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasParent),
      expression: "!hasParent"
    }],
    staticClass: "sc-price-info",
    class: {
      fadeInRight: _vm.show
    }
  }, [_c('div', {
    staticClass: "sc-price"
  }, [_vm._v("\n          $" + _vm._s(parseInt(_vm.price))), _c('span', {
    staticClass: "small"
  }, [_vm._v("." + _vm._s(_vm.price.split(".")[1]))]), _vm._v(" "), (_vm.vat > 0) ? _c('span', {
    staticClass: "sc-price-info-vat"
  }, [_vm._v("+$" + _vm._s(_vm.vat) + " VAT")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "sc-messages"
  }, [(_vm.resultErrorMessage.length) ? _c('p', {
    staticClass: "sc-error-text",
    domProps: {
      "innerHTML": _vm._s(_vm.resultErrorMessage)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.walletError) ? _c('p', {
    staticClass: "sc-error-text",
    domProps: {
      "innerHTML": _vm._s(_vm.walletError)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.offer.options.length > 1) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThirdParty && !_vm.hasParent),
      expression: "!isThirdParty && !hasParent"
    }],
    staticClass: "sc-product-options"
  }, [_c('h2', [_vm._v("Product option")]), _vm._v(" "), _c('BaseFormRow', [_c('div', {
    staticClass: "sc-form-select-container sc-form-product-options"
  }, [_c('div', {
    staticClass: "sc-select-box",
    class: {
      'sc-select-has-error': _vm.errors.includes('optionId') ?
        true :
        false,
    }
  }, [_c('div', {
    ref: "product-options-sc-selectbox",
    staticClass: "sc-select-button brd",
    class: {
      'open-select-box': _vm.showProductOptions,
    },
    style: (("z-index:" + (_vm.highestZIndex + 17))),
    on: {
      "click": function($event) {
        _vm.showProductOptions = !_vm.showProductOptions
      }
    }
  }, [_c('div', {
    staticClass: "sc-selected-value"
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm._f("TitleString")(_vm.selectedProductOption.name ||
    "Product Options")) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "sc-select-chevrons"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/symbols-arrow.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInFast",
      "mode": "out-in"
    }
  }, [(_vm.showProductOptions) ? _c('div', {
    directives: [{
      name: "closable",
      rawName: "v-closable",
      value: ({
        exclude: ['product-options-sc-selectbox'],
        handler: 'onCloseProductOptions',
      }),
      expression: "{\n                  exclude: ['product-options-sc-selectbox'],\n                  handler: 'onCloseProductOptions',\n                }"
    }],
    staticClass: "sc-options",
    style: (("z-index:" + (_vm.highestZIndex + 16)))
  }, _vm._l((_vm.offer.options), function(option, index) {
    return _c('div', {
      key: 'product_options_' + index + '_' + option.name,
      staticClass: "sc-option",
      class: {
        'sc-selected': option.ID == _vm.form.optionId
      },
      on: {
        "click": function($event) {
          _vm.form.optionId = option.ID
        }
      }
    }, [_c('span', {
      staticClass: "sc-select-option-label"
    }, [_vm._v("\n                      " + _vm._s(_vm._f("TitleString")(option.name)) + "\n                      ")])])
  }), 0) : _vm._e()])], 1)])])], 1) : _c('p'), _vm._v(" "), (!_vm.isWalletSetup) ? [_c('BaseFormRow', [_c('div', {
    staticClass: "sc-form-select-container sc-user-type"
  }, [_c('div', {
    staticClass: "sc-select-box",
    class: {
      'sc-select-has-error': _vm.errors.includes('user_type') ?
        true :
        false,
    }
  }, [_c('label', {
    attrs: {
      "for": "user_type"
    }
  }, [_vm._v("I'm a")]), _vm._v(" "), _c('div', {
    ref: "user-type-sc-selectbox",
    staticClass: "sc-select-button brd",
    class: {
      'open-select-box': _vm.showUserTypes,
    },
    on: {
      "click": function($event) {
        _vm.showUserTypes = !_vm.showUserTypes
      }
    }
  }, [_c('div', {
    staticClass: "sc-selected-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.activeUserType))])]), _vm._v(" "), _c('div', {
    staticClass: "sc-select-chevrons cursor-pointer"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/symbols-arrow.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInFast",
      "mode": "out-in"
    }
  }, [(_vm.showUserTypes) ? _c('div', {
    directives: [{
      name: "closable",
      rawName: "v-closable",
      value: ({
        exclude: ['user-type-sc-selectbox'],
        handler: 'onCloseUserType',
      }),
      expression: "{\n                  exclude: ['user-type-sc-selectbox'],\n                  handler: 'onCloseUserType',\n                }"
    }],
    staticClass: "sc-options"
  }, [_c('div', {
    key: "user_type_1",
    staticClass: "sc-option",
    class: {
      'sc-selected': _vm.form.user_type == 1
    },
    on: {
      "click": function($event) {
        _vm.form.user_type = 1
      }
    }
  }, [_c('span', {
    staticClass: "sc-select-option-label"
  }, [_vm._v("Private User")])]), _vm._v(" "), _c('div', {
    key: "user_type_2",
    staticClass: "sc-option",
    class: {
      'sc-selected': _vm.form.user_type == 2
    },
    on: {
      "click": function($event) {
        _vm.form.user_type = 2
      }
    }
  }, [_c('span', {
    staticClass: "sc-select-option-label"
  }, [_vm._v("Business")])]), _vm._v(" "), _c('div', {
    key: "user_type_3",
    staticClass: "sc-option",
    class: {
      'sc-selected': _vm.form.user_type == 3
    },
    on: {
      "click": function($event) {
        _vm.form.user_type = 3
      }
    }
  }, [_c('span', {
    staticClass: "sc-select-option-label"
  }, [_vm._v("Organization")])]), _vm._v(" "), _c('div', {
    key: "user_type_4",
    staticClass: "sc-option",
    class: {
      'sc-selected': _vm.form.user_type == 4
    },
    on: {
      "click": function($event) {
        _vm.form.user_type = 4
      }
    }
  }, [_c('span', {
    staticClass: "sc-select-option-label"
  }, [_vm._v("Sole trader")])])]) : _vm._e()])], 1)]), _vm._v(" "), (!_vm.userId) ? [(_vm.isSelfHosted && !_vm.iframe) ? _c('a', {
    staticClass: "sc-login-link flex",
    attrs: {
      "data-target": "#login",
      "data-toggle": "modal",
      "data-dismiss": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    },
    on: {
      "click": _vm.closeCheckout
    }
  }, [_vm._v("\n              Already a user?"), _c('span', {
    staticClass: "has-tooltip"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/info.svg"),
      "alt": "info"
    }
  }), _vm._v(" "), _c('BaseToolTip', {
    staticClass: "tooltip-text",
    attrs: {
      "text": "This product is sold on Sellcodes.com. If you already have a Sellcodes account, please click to login.",
      "tip": "bottom-right"
    }
  })], 1)]) : _c('a', {
    staticClass: "sc-login-link flex",
    attrs: {
      "target": "_blank",
      "href": (_vm.scBaseUrl + "/" + (_vm.offer.secret_link) + "/?embLogin=1")
    }
  }, [_vm._v("\n              Already a user?"), _c('span', {
    staticClass: "has-tooltip"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/info.svg"),
      "alt": "info"
    }
  }), _vm._v(" "), _c('BaseToolTip', {
    staticClass: "tooltip-text",
    attrs: {
      "text": "This product is sold on Sellcodes.com. If you already have a Sellcodes account, please click to login.",
      "tip": "bottom-right"
    }
  })], 1)])] : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInTop",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [([2, 3, 4].includes(_vm.form.user_type)) ? _c('div', {
    key: "businessUserBlock",
    attrs: {
      "id": "businessUserBlock"
    }
  }, [_c('BaseFormRow', [_c('BaseInput', {
    staticClass: "mrgrt-8",
    attrs: {
      "id": (_vm.widgetKey + "_business_name"),
      "placeholder": "Business name",
      "error": _vm.errors.includes('business_name') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('business_name') ?
        _vm.errorMessages.business_name :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.business_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "business_name", $$v)
      },
      expression: "form.business_name"
    }
  }), _vm._v(" "), _c('BaseSelect', {
    staticClass: "mrglt-8",
    attrs: {
      "id": (_vm.widgetKey + "_residence_business"),
      "placeholder": "Business residence",
      "options": _vm.countries,
      "option-label": "name",
      "option-value": "alpha_2",
      "option-input": "alpha_3",
      "option-sub-label": "alpha_3",
      "label": "Business residence",
      "error": _vm.errors.includes('residence_business') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('residence_business') ?
        _vm.errorMessages.residence_business :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.residence_business),
      callback: function($$v) {
        _vm.$set(_vm.form, "residence_business", $$v)
      },
      expression: "form.residence_business"
    }
  })], 1), _vm._v(" "), (_vm.isEU && !_vm.showEUVat) ? _c('BaseFormRow', [_c('a', {
    staticClass: "vat-toggle-link",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.showEUVat = !_vm.showEUVat
      }
    }
  }, [_vm._v("Have an EU VAT number?")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInTop",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.isEU && _vm.showEUVat) ? [_c('BaseFormRow', [_c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_eu_vat_number"),
      "placeholder": "EU VAT number",
      "error": _vm.form.eu_vat_number.length &&
        (_vm.errors.includes('eu_vat_number') ||
          _vm.errorMessages.hasOwnProperty('eu_vat_number')) ?
        true :
        false,
      "success": _vm.form.eu_vat_valid == 1 && _vm.form.eu_vat_number.length,
      "success-message": _vm.successMessages.hasOwnProperty('eu_vat_number') ?
        _vm.successMessages.eu_vat_number :
        '',
      "error-message": _vm.errorMessages.hasOwnProperty('eu_vat_number') ?
        _vm.errorMessages.eu_vat_number :
        '',
      "size": "w-75",
      "is-vat": true
    },
    model: {
      value: (_vm.form.eu_vat_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "eu_vat_number", $$v)
      },
      expression: "form.eu_vat_number"
    }
  }), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "size": "w-25 h-40",
      "variant": "invert",
      "type": "button",
      "loading": _vm.vatLoader
    },
    on: {
      "click": function($event) {
        return _vm.checkVatNumber('vat')
      }
    }
  }, [_vm._v("Check")])], 1)] : _vm._e()], 2), _vm._v(" "), _c('BaseFormRow', [_c('h2', [_vm._v("Legal representative")])]), _vm._v(" "), _c('BaseFormRow', [_c('BaseInput', {
    staticClass: "mrgrt-8",
    attrs: {
      "id": (_vm.widgetKey + "_first_name_b"),
      "placeholder": "First name",
      "size": "w-50",
      "error": _vm.errors.includes('first_name') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('first_name') ?
        _vm.errorMessages.first_name :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.first_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "first_name", $$v)
      },
      expression: "form.first_name"
    }
  }), _vm._v(" "), _c('BaseInput', {
    staticClass: "mrglt-8",
    attrs: {
      "id": (_vm.widgetKey + "_last_name_b"),
      "placeholder": "Last name",
      "error": _vm.errors.includes('last_name') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('last_name') ?
        _vm.errorMessages.last_name :
        '',
      "tip": _vm.tipALign,
      "required": true,
      "size": "w-50"
    },
    model: {
      value: (_vm.form.last_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "last_name", $$v)
      },
      expression: "form.last_name"
    }
  })], 1), _vm._v(" "), (!_vm.userId) ? _c('BaseFormRow', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThirdParty),
      expression: "!isThirdParty"
    }],
    class: {
      'mb-0': _vm.isEmailExist,
    }
  }, [_c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_email_b"),
      "placeholder": "Your email",
      "readonly": _vm.readOnly.includes('email') ? true : false,
      "error": _vm.errors.includes('email') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('email') ?
        _vm.errorMessages.email :
        '',
      "validation": "email",
      "tip": _vm.tipALign,
      "type": "email"
    },
    on: {
      "blur": _vm.checkEmailExist
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEmailExist) ? _c('p', {
    staticClass: "email-exists-error"
  }, [_vm._v("\n              You already seem to have a Sellcodes account.\n              "), (_vm.isSelfHosted) ? _c('a', {
    staticClass: "sc-login-link flex",
    attrs: {
      "data-target": "#login",
      "data-toggle": "modal",
      "data-dismiss": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_vm._v("\n                Please login\n              ")]) : _c('a', {
    staticClass: "sc-login-link flex",
    attrs: {
      "target": "_blank",
      "href": (_vm.scBaseUrl + "/" + (_vm.offer.secret_link) + "/?embLogin=1")
    }
  }, [_vm._v("\n                Please login\n              ")])]) : _vm._e()], 1) : _c('div', {
    key: "privateUserBlock"
  }, [_c('BaseFormRow', [_c('BaseInput', {
    staticClass: "mrgrt-8",
    attrs: {
      "id": (_vm.widgetKey + "_first_name"),
      "placeholder": "First name",
      "size": "w-50",
      "required": true,
      "error": _vm.errors.includes('first_name') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('first_name') ?
        _vm.errorMessages.first_name :
        ''
    },
    model: {
      value: (_vm.form.first_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "first_name", $$v)
      },
      expression: "form.first_name"
    }
  }), _vm._v(" "), _c('BaseInput', {
    staticClass: "mrglt-8",
    attrs: {
      "id": (_vm.widgetKey + "_last_name"),
      "placeholder": "Last name",
      "required": true,
      "error": _vm.errors.includes('last_name') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('last_name') ?
        _vm.errorMessages.last_name :
        '',
      "tip": _vm.tipALign,
      "size": "w-50"
    },
    model: {
      value: (_vm.form.last_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "last_name", $$v)
      },
      expression: "form.last_name"
    }
  })], 1), _vm._v(" "), (!_vm.userId) ? _c('BaseFormRow', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isThirdParty),
      expression: "!isThirdParty"
    }],
    class: {
      'mb-0': _vm.isEmailExist,
    }
  }, [_c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_email"),
      "placeholder": "Your email",
      "readonly": _vm.readOnly.includes('email') ? true : false,
      "error": _vm.errors.includes('email') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('email') ?
        _vm.errorMessages.email :
        '',
      "validation": "email",
      "tip": _vm.tipALign,
      "type": "email"
    },
    on: {
      "blur": _vm.checkEmailExist
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isEmailExist) ? _c('p', {
    staticClass: "email-exists-error"
  }, [_vm._v("\n              You already seem to have a Sellcodes account.\n              "), (_vm.isSelfHosted) ? _c('a', {
    staticClass: "sc-login-link flex",
    attrs: {
      "data-target": "#login",
      "data-toggle": "modal",
      "data-dismiss": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_vm._v("\n                Please login\n              ")]) : _c('a', {
    staticClass: "sc-login-link flex",
    attrs: {
      "target": "_blank",
      "href": (_vm.scBaseUrl + "/" + (_vm.offer.secret_link) + "/?embLogin=1")
    }
  }, [_vm._v("\n                Please login\n              ")])]) : _vm._e()], 1)])] : _vm._e(), _vm._v(" "), _c('BaseFormRow', {
    staticClass: "sc-payment-method-header"
  }, [_c('div', {
    staticClass: "w-50 sc-tab-credit-card",
    on: {
      "click": function($event) {
        return _vm.togglePayMethod(0)
      }
    }
  }, [_vm._v("\n          Credit card\n        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasParent && _vm.availableProviders.includes('PAYPAL')),
      expression: "!hasParent && availableProviders.includes('PAYPAL')"
    }],
    staticClass: "w-50 sc-tab-paypal",
    on: {
      "click": function($event) {
        return _vm.togglePayMethod(1)
      }
    }
  }, [_vm._v("\n          or pay with\n          "), _c('span', [_c('img', {
    staticClass: "sc-purchase-modal__paypal-method-img",
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/paypal_method.png"),
      "alt": "paypal"
    }
  })])])]), _vm._v(" "), (!_vm.form.pay_method && !_vm.isSecondaryCheckout && !_vm.availableProviders.includes('PAYPAL')) ? _c('p', {
    staticClass: "sc-error-text"
  }, [_vm._v("We're currently facing\n        issues with our payment system. Please contact us at support@sellcodes.com so that we can arrange alternative\n        ways of payments, or notify you when the issue is corrected. Thank you!")]) : (!_vm.form.pay_method && !_vm.isSecondaryCheckout) ? _c('p', {
    staticClass: "sc-error-text"
  }, [_vm._v("Our Credit Card payment processor is\n        facing issues. Please pay via PayPal, or contact us at support@sellcodes.com so that we can arrange alternative\n        ways of payments, or notify you when the issue is corrected. Thank you!")]) : _vm._e(), _vm._v(" "), ((false && !_vm.form.pay_method && !_vm.isSecondaryCheckout)) ? _c('div', {
    staticClass: "sc-credit-card",
    class: _vm.errors.includes('credit_card_number') ||
      _vm.errors.includes('credit_card_expiry') ||
      _vm.errors.includes('credit_card_cvc') ?
      'has-error' :
      ''
  }, [_c('div', {
    staticClass: "sc-credit-card-number",
    class: {
      'has-tooltip': _vm.errorMessages.hasOwnProperty('credit_card_number'),
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.credit_card_number),
      expression: "form.credit_card_number"
    }],
    staticClass: "sc-credit-card-input",
    attrs: {
      "id": (_vm.widgetKey + "_credit_card_number"),
      "autocomplete": "cc-number",
      "placeholder": "Card number"
    },
    domProps: {
      "value": (_vm.form.credit_card_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "credit_card_number", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.errorMessages.hasOwnProperty('credit_card_number')) ? _c('div', {
    staticClass: "input-error"
  }, [_c('div', {
    staticClass: "has-tooltip"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/Error.svg"),
      "alt": "Error"
    }
  }), _vm._v(" "), (_vm.errorMessages.credit_card_number) ? _c('BaseToolTip', {
    ref: ("tooltip-error-" + (_vm.form.credit_card_number)),
    staticClass: "tooltip-input",
    attrs: {
      "tip": "bottom-left"
    }
  }, [_vm._v(_vm._s(_vm.errorMessages.credit_card_number))]) : _vm._e()], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_" + _vm.randomKey + "_credit_card_expiry"),
      "class-name": "sc-credit-card-expiry",
      "placeholder": "MM/YY",
      "error": _vm.errors.includes('credit_card_expiry') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('credit_card_expiry') ?
        _vm.errorMessages.credit_card_expiry :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.credit_card_expiry),
      callback: function($$v) {
        _vm.$set(_vm.form, "credit_card_expiry", $$v)
      },
      expression: "form.credit_card_expiry"
    }
  }), _vm._v(" "), _c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_" + _vm.randomKey + "_credit_card_cvc"),
      "placeholder": "CVC",
      "class-name": "sc-credit-card-cvc",
      "error": _vm.errors.includes('credit_card_cvc') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('credit_card_cvc') ?
        _vm.errorMessages.credit_card_cvc :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.credit_card_cvc),
      callback: function($$v) {
        _vm.$set(_vm.form, "credit_card_cvc", $$v)
      },
      expression: "form.credit_card_cvc"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSecondaryCheckout),
      expression: "isSecondaryCheckout"
    }],
    staticClass: "sc-stripe-card-element",
    class: _vm.errors.includes('credit_card_number') ||
      _vm.errors.includes('credit_card_expiry') ||
      _vm.errors.includes('credit_card_cvc') ?
      'has-error' :
      '',
    attrs: {
      "id": (_vm.formRef + "card-element")
    }
  }, [_c('div', {
    staticClass: "sc-stripe-card-number-element",
    attrs: {
      "id": (_vm.formRef + "cardNumber")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sc-stripe-card-expiry-element",
    attrs: {
      "id": (_vm.formRef + "cardExpiry")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sc-stripe-card-cvc-element",
    attrs: {
      "id": (_vm.formRef + "cardCvc")
    }
  })]), _vm._v(" "), (!_vm.isWalletSetup) ? [_c('BaseFormRow', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "sc-referral-row"
  }, [_c('p', [_vm._v("\n            Information for earning referral commissions\n            "), _c('span', {
    staticClass: "has-tooltip"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/info.svg"),
      "alt": "info"
    }
  }), _vm._v(" "), _c('BaseToolTip', {
    staticClass: "tooltip-text",
    attrs: {
      "text": "If you like the product you're buying, you can refer it to friends and earn referral commissions (40% of the purchase price). Those commissions will be stored in your digital wallet which is kind of a «mini bank account» so we are <a href='https://sellcodes.com/support/wallet' target='_blank'>legally required</a> to ask for this information. Obviously, we'll treat it <a href='https://sellcodes.com/privacy' target='_blank'>highly confidentially</a>.",
      "tip": "bottom-right",
      "size": "lg"
    }
  })], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInTop",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.form.is_referral) ? _c('div', [([2].includes(_vm.form.user_type)) ? [_c('BaseFormRow', [_c('h2', [_vm._v("Company number")])]), _vm._v(" "), _c('BaseFormRow', [_c('BaseInput', {
    staticClass: "mrgrt-8",
    attrs: {
      "id": (_vm.widgetKey + "_company_number"),
      "validation": "alphanumeric",
      "placeholder": "Company number",
      "error": _vm.errors.includes('company_number') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('company_number') ?
        _vm.errorMessages.company_number :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.company_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "company_number", $$v)
      },
      expression: "form.company_number"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.form.user_type > 1) ? [_c('BaseFormRow', [_c('h2', [_vm._v("Headquarter address")])]), _vm._v(" "), _c('BaseFormRow', [_c('BaseInput', {
    staticClass: "mrgrt-8",
    attrs: {
      "id": (_vm.widgetKey + "_address1"),
      "placeholder": "Address line 1",
      "error": _vm.errors.includes('address1') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('address1') ?
        _vm.errorMessages.address1 :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.address1),
      callback: function($$v) {
        _vm.$set(_vm.form, "address1", $$v)
      },
      expression: "form.address1"
    }
  }), _vm._v(" "), _c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_address2"),
      "placeholder": "Address line 2",
      "error": _vm.errors.includes('address2') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('address2') ?
        _vm.errorMessages.address2 :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.address2),
      callback: function($$v) {
        _vm.$set(_vm.form, "address2", $$v)
      },
      expression: "form.address2"
    }
  })], 1), _vm._v(" "), _c('BaseFormRow', [_c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_city"),
      "placeholder": "City",
      "error": _vm.errors.includes('city') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('city') ?
        _vm.errorMessages.city :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  }), _vm._v(" "), _c('BaseInput', {
    staticClass: "mrglt-8",
    attrs: {
      "id": (_vm.widgetKey + "_state"),
      "placeholder": "State",
      "error": _vm.errors.includes('state') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('state') ?
        _vm.errorMessages.state :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.state),
      callback: function($$v) {
        _vm.$set(_vm.form, "state", $$v)
      },
      expression: "form.state"
    }
  }), _vm._v(" "), _c('BaseInput', {
    staticClass: "mrglt-8",
    attrs: {
      "id": (_vm.widgetKey + "_post_code"),
      "placeholder": "Postcode",
      "error": _vm.errors.includes('post_code') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('post_code') ?
        _vm.errorMessages.post_code :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.post_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "post_code", $$v)
      },
      expression: "form.post_code"
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('BaseFormRow', {
    staticClass: "sc-referral-box"
  }, [_c('BaseDatePicker', {
    attrs: {
      "id": (_vm.widgetKey + "_dob"),
      "label": "Birthday",
      "placeholder": "Date of birth",
      "error": _vm.errors.includes('dob') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('dob') ? _vm.errorMessages.dob : ''
    },
    model: {
      value: (_vm.form.dob),
      callback: function($$v) {
        _vm.$set(_vm.form, "dob", $$v)
      },
      expression: "form.dob"
    }
  }), _vm._v(" "), _c('BaseSelect', {
    staticClass: "mrglt-8",
    attrs: {
      "id": (_vm.widgetKey + "_residence"),
      "placeholder": "Residence",
      "options": _vm.countries,
      "option-label": "name",
      "option-value": "alpha_2",
      "option-input": "alpha_3",
      "option-sub-label": "alpha_3",
      "label": "Residence",
      "error": _vm.errors.includes('residence') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('residence') ?
        _vm.errorMessages.residence :
        '',
      "required": true,
      "scroll-height": -220,
      "scroll-multiplier": 6
    },
    model: {
      value: (_vm.form.residence),
      callback: function($$v) {
        _vm.$set(_vm.form, "residence", $$v)
      },
      expression: "form.residence"
    }
  }), _vm._v(" "), _c('BaseSelect', {
    staticClass: "mrglt-8",
    attrs: {
      "id": (_vm.widgetKey + "_nationality"),
      "placeholder": "Nationality",
      "options": _vm.countries,
      "option-label": "nationality",
      "option-value": "alpha_2",
      "option-input": "alpha_3",
      "option-sub-label": "alpha_3",
      "label": "Nationality",
      "error": _vm.errors.includes('nationality') ? true : false,
      "error-message": _vm.errorMessages.hasOwnProperty('nationality') ?
        _vm.errorMessages.nationality :
        '',
      "required": true
    },
    model: {
      value: (_vm.form.nationality),
      callback: function($$v) {
        _vm.$set(_vm.form, "nationality", $$v)
      },
      expression: "form.nationality"
    }
  })], 1)], 2) : _vm._e()])] : _c('p', {
    staticClass: "mrgt-10"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInTop",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.showDiscount) ? _c('BaseFormRow', [_c('BaseInput', {
    attrs: {
      "id": (_vm.widgetKey + "_discount_code"),
      "placeholder": "Discount Code",
      "size": "w-75",
      "error": _vm.errors.includes('discount_code') ||
        _vm.errorMessages.hasOwnProperty('discount_code') ?
        true :
        false,
      "success": _vm.form.discount_code.length > 0 &&
        _vm.successMessages.hasOwnProperty('discount_code'),
      "success-message": _vm.successMessages.hasOwnProperty('discount_code') ?
        _vm.successMessages.discount_code :
        '',
      "error-message": _vm.errorMessages.hasOwnProperty('discount_code') ?
        _vm.errorMessages.discount_code :
        '',
      "is-vat": true
    },
    model: {
      value: (_vm.form.discount_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "discount_code", $$v)
      },
      expression: "form.discount_code"
    }
  }), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "size": "w-25 h-40",
      "variant": "invert",
      "type": "button",
      "disabled": !_vm.form.discount_code.length,
      "loading": _vm.dCodeLoader
    },
    on: {
      "click": function($event) {
        return _vm.checkVatNumber('dcode')
      }
    }
  }, [_vm._v("Apply")])], 1) : _vm._e()], 1), _vm._v(" "), _c('BaseFormRow', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasParent),
      expression: "!hasParent"
    }]
  }, [(this.discount.status != 1) ? _c('div', {
    staticClass: "sc-buy-text"
  }, [_vm._v("\n          You are buying \""), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.offer.title)
    }
  }), _vm._v("\" and will be\n          charged $" + _vm._s(_vm.price)), (_vm.vat > 0) ? _c('span', [_vm._v(" (+ $" + _vm._s(_vm.vat) + " VAT)")]) : _vm._e()]) : _c('div', {
    staticClass: "sc-buy-text"
  }, [_vm._v("\n          You are buying \"" + _vm._s(_vm.offer.title) + "\" and will be charged\n          "), _c('span', {
    staticClass: "original-price"
  }, [_vm._v("$" + _vm._s(_vm.originalPrice)), (_vm.originalPriceVat > 0) ? _c('span', [_vm._v(" (+ $" + _vm._s(_vm.originalPriceVat) + " VAT)")]) : _vm._e()]), _vm._v("\n          $" + _vm._s(_vm.price)), (_vm.vat > 0) ? _c('span', [_vm._v(" (+ $" + _vm._s(_vm.vat) + " VAT)")]) : _vm._e()])]), _vm._v(" "), _c('BaseFormRow', {
    staticClass: "relative mrgbt-0"
  }, [_c('BaseButton', {
    attrs: {
      "variant": "big-button",
      "type": "button"
    },
    on: {
      "click": _vm._submitForm
    }
  }, [_vm._v(_vm._s(_vm.payButtonText))])], 1), _vm._v(" "), (_vm.offer.faq && _vm.offer.faq.status) ? _c('p', {
    staticClass: "sc-faq-wrap"
  }, [_c('Faq', {
    attrs: {
      "faq": _vm.offer.faq
    }
  })], 1) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    key: "`sc-form-footer-${offer.secret}`",
    staticClass: "sc-form-footer",
    style: (("z-index:" + _vm.highestZIndex))
  }, [_c('PaySuccessComponent', {
    attrs: {
      "showSuccess": _vm.resultMessage.length,
      "resultMessage": _vm.resultMessage
    }
  }), _vm._v(" "), _c('BaseFormRow', [_c('div', {
    staticClass: "sc-buy-info"
  }, [_c('div', {
    staticClass: "has-tooltip"
  }, [_c('a', {
    staticClass: "license_display sc-popup__title",
    domProps: {
      "innerHTML": _vm._s(_vm.licenseText)
    }
  }), _vm._v(" "), (_vm.licenceTextTooltip) ? _c('BaseToolTip', {
    staticClass: "tooltip-text",
    attrs: {
      "show": _vm.licenceTextTooltipShow,
      "text": _vm.licenceTextTooltip,
      "tip": "bottom-right"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "sc-separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    staticClass: "has-tooltip"
  }, [_c('a', {
    staticClass: "pricing_display sc-popup__title"
  }, [_vm._v(_vm._s(_vm.isRecurring ? "Recurring pricing" : "One-time charge"))]), _vm._v(" "), (_vm.chargeTooltip) ? _c('BaseToolTip', {
    staticClass: "tooltip-text",
    attrs: {
      "show": _vm.chargeTooltipShow,
      "tip": "bottom-right"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.chargeTooltip) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), (this.form.pay_method != '') ? [_c('span', {
    staticClass: "sc-separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    staticClass: "has-tooltip"
  }, [_c('a', {
    staticClass: "sc-popup",
    on: {
      "click": _vm.toggleDiscountBox
    }
  }, [_vm._v("D-codes")]), _vm._v(" "), (_vm.dcodeTextTooltip) ? _c('BaseToolTip', {
    staticClass: "tooltip-text",
    attrs: {
      "show": _vm.dcodeTextTooltipShow,
      "text": _vm.dcodeTextTooltip,
      "tip": "bottom-right"
    }
  }) : _vm._e()], 1)] : _vm._e()], 2)]), _vm._v(" "), _c('BaseFormRow', [_c('div', {
    key: "`sc-form-footer-${offer.secret}`",
    staticClass: "sc-secure-info"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/Secure.svg"),
      "alt": ""
    }
  }), _vm._v(" SECURE\n        Checkout using SSL data encryption\n      ")])]), _vm._v(" "), _c('BaseFormRow', [_c('p', [_vm._v("\n        Sold via & Fulfilled by\n        "), _c('a', {
    attrs: {
      "href": _vm.scBaseUrl,
      "target": "_blank"
    }
  }, [_vm._v("Sellcodes")]), _vm._v(", an authorised\n        "), (_vm.windowWidth < 376) ? _c('br') : _vm._e(), _vm._v("marketplace for\n        "), (_vm.windowWidth > 375) ? _c('br') : _vm._e(), _vm._v("software, in collabaration with\n        "), (_vm.windowWidth < 376) ? _c('br') : _vm._e(), _vm._v("payment provider Mangopay.\n      ")])]), _vm._v(" "), _c('BaseFormRow', [_c('p', {
    staticClass: "mrgt-10 mrgbt-20"
  }, [_vm._v("\n        All data is treated highly confidentially, see our\n        "), _c('a', {
    attrs: {
      "href": (_vm.scBaseUrl + "/privacy"),
      "target": "_blank"
    }
  }, [_vm._v("\n          Privacy\n          "), (_vm.windowWidth < 376) ? _c('br') : _vm._e(), _vm._v("Policy\n        ")]), _vm._v("\n        and\n        "), (_vm.windowWidth > 375) ? _c('br') : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": (_vm.scBaseUrl + "/terms"),
      "target": "_blank"
    }
  }, [_vm._v("Terms of Use")]), _vm._v("\n        to which you agree to\n        "), (_vm.windowWidth < 376) ? _c('br') : _vm._e(), _vm._v("with your purchase.\n      ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45176e12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckoutFormComponent.vue
// module id = 112
// module chunks = 0